import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/product/detail/:id(\\d+)/:aid([a-zA-Z0-9]+)?',
      name: 'Product',
      component: () => import('@/views/product/detail'),
      meta: {
        title: '产品'
      }
    },
    {
      path: '/event/god',
      name: 'EventGod',
      component: () => import('@/views/event/god'),
      meta: {
        title: '活动总览'
      }
    },
    {
      path: '/event/join/:gid(\\d+)?',
      name: 'EventJoinGroup',
      component: () => import('@/views/event/join-group'),
      meta: {
        title: '邀请你加入小组'
      }
    },
    {
      path: '/event/group',
      name: 'EventGroup',
      component: () => import('@/views/event/group'),
      meta: {
        title: '我的小组'
      }
    },
    {
      path: '/event/score/:id([a-zA-Z0-9]+)?',
      name: 'EventScore',
      component: () => import('@/views/event/score'),
      meta: {
        title: '有奖评选'
      }
    },
    {
      path: '/event/myscore',
      name: 'EventMyScore',
      component: () => import('@/views/event/myscore'),
      meta: {
        title: '我的得分'
      }
    },
    {
      path: '/program/detail/:id(\\d+)/:aid([a-zA-Z0-9]+)?',
      name: 'Program',
      component: () => import('@/views/program/detail'),
      meta: {
        title: '课程'
      }
    },
    {
      path: '/product/order/:sn([a-zA-Z0-9]+)',
      name: 'ProductOrder',
      component: () => import('@/views/order/pay'),
      meta: {
        title: '产品订单结算'
      }
    },
    {
      path: '/program/order/:sn([a-zA-Z0-9]+)',
      name: 'ProgramOrder',
      component: () => import('@/views/order/pay'),
      meta: {
        title: '课程订单结算'
      }
    },
    {
      path: '/program/view/:id([a-zA-Z0-9]+)',
      name: 'ProgramView',
      component: () => import('@/views/program/view'),
      meta: {
        title: '课程观看'
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: () => import('@/views/order/index'),
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/order/detail/:sn([a-zA-Z0-9]+)',
      name: 'OrderDetaily',
      component: () => import('@/views/order/pay'),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/order/pay/:sn([a-zA-Z0-9]+)',
      name: 'OrderPay',
      component: () => import('@/views/order/pay'),
      meta: {
        title: '订单结算'
      }
    },
    {
      path: '/member/profile',
      name: 'MemberProfile',
      component: () => import('@/views/member/profile'),
      meta: {
        title: '会员信息'
      }
    },
    {
      path: '/member/partner-profile',
      name: 'MemberPartnerProfile',
      component: () => import('@/views/member/partner-profile'),
      meta: {
        title: '合伙人信息'
      }
    },
    {
      path: '/member/inviter/:aid([a-zA-Z0-9]+)/:type(\\d+)',
      name: 'MemberInviter',
      component: () => import('@/views/member/inviter'),
      meta: {
        title: '会员邀请'
      }
    },
    {
      path: '/member/center/:aid([a-zA-Z0-9]+)?',
      name: 'MemberCenter',
      component: () => import('@/views/member/center'),
      meta: {
        title: '会员中心'
      }
    },
    {
      path: '/member/resource',
      name: 'MemberResource',
      component: () => import('@/views/member/resource'),
      meta: {
        title: '我的资源'
      }
    },
    {
      path: '/auth/:uid(.*)?',
      name: 'Auth',
      component: () => import('@/views/member/auth'),
      meta: {
        title: '安全登录'
      }
    },
    {
      path: '/auth-jump',
      name: 'AuthJump',
      component: () => import('@/views/member/auth-jump'),
      meta: {
        title: '微信跳转'
           }
    },
    {
      path: '/proxy',
      name: 'proxy',
      component: () => import('@/views/proxy/index'),
      meta: {
        title: '渠道中心'
      }
    },
    {
      path: '/proxy/team',
      name: 'proxyTeam',
      component: () => import('@/views/proxy/team'),
      meta: {
        title: '我的客户'
      }
    },
    {
      path: '/proxy/order',
      name: 'proxyOrder',
      component: () => import('@/views/proxy/order'),
      meta: {
        title: '客户的订单'
      }
    },
    {
      path: '/proxy/bill',
      name: 'proxyBill',
      component: () => import('@/views/proxy/bill'),
      meta: {
        title: '财务结算'
      }
    },
    {
      path: '/proxy/bill-log',
      name: 'proxyBillLog',
      component: () => import('@/views/proxy/bill-log'),
      meta: {
        title: '结算记录'
      }
    },
    {
      path: '/proxy/promote',
      name: 'proxyPromote',
      component: () => import('@/views/proxy/promote'),
      meta: {
        title: '推广中心'
      }
    },
    {
      path: '/proxy/material',
      name: 'proxyMaterial',
      component: () => import('@/views/proxy/material'),
      meta: {
        title: '推广素材'
      }
    },
    // resource 
    {
      path: '/resource',
      name: 'Resource',
      component: () => import('@/views/resource/index'),
      meta: {
        title: '资源中心'
      }
    },
    {
      path: '/resource/docking',
      name: 'ResourceDocking',
      component: () => import('@/views/resource/docking'),
      meta: {
        title: '资源对接单'
      } 
    },
    // h5
    {
      path: '/h5/layout/:id([a-zA-Z0-9]+)',
      name: 'Layout',
      component: () => import('@/views/h5/layout/index'),
      meta: {
        title: '表单'
      }
    },
    {
      path: '/form/:id([a-zA-Z0-9]+)',
      name: 'Form2',
      component: () => import('@/views/form/index'),
      meta: {
        title: '表单'
      }
    },
    {
      path: '/html/player/:id([a-zA-Z0-9]+)?',
      name: 'HtmlPlayer',
      component: () => import('@/views/html/player'),
      meta: {
        title: '文档预览'
      }
    },
    {
      path: '/h5/enrollment/:id([a-zA-Z0-9]+)',
      name: 'Enrollment',
      component: () => import('@/views/h5/enrollment'),
      meta: {
        title: '招生简章'
      }
    },
    {
      path: '/h5/western-philosophy/:id([a-zA-Z0-9]+)',
      name: 'WesternPhilosophy',
      component: () => import('@/views/h5/western-philosophy'),
      meta: {
        title: 'western-philosophy'
      } 
    },
    {
      path: '/h5/zhijian/:id([a-zA-Z0-9]+)',
      name: 'zhijian',
      component: () => import('@/views/h5/zhijian'),
      meta: {
        title: 'zhijian'
      } 
    },
    {
      path: '/h5/zhijian-info/:id([a-zA-Z0-9]+)',
      name: 'zhijianInfo',
      component: () => import('@/views/h5/zhijian-info'),
      meta: {
        title: 'zhijian-info'
      } 
    },
    {
      path: '/h5/three-days/:id([a-zA-Z0-9]+)',// 使用频率极低
      name: 'ThreeDays',
      component: () => import('@/views/h5/three-days'),
      meta: {
        title: 'three-days'
      } 
    },
    {
      path: '/h5/western-audition/:id([a-zA-Z0-9]+)',
      name: 'WesternAudition',
      component: () => import('@/views/h5/western-audition'),
      meta: {
        title: 'western-audition'
      } 
    },
    {
      path: '/h5/design-mode/:id([a-zA-Z0-9]+)',
      name: 'DesignMode',
      component: () => import('@/views/h5/design-mode'),
      meta: {
        title: '知见表单'
      } 
    },
    {
      path: '/h5/design-form/:id([a-zA-Z0-9]+)',
      name: 'DesignForm',
      component: () => import('@/views/h5/design-form'),
      meta: {
        title: '知见表单'
      } 
    },
    {
      path: '/h5/design-audition/:id([a-zA-Z0-9]+)',
      name: 'DesignAudition',
      component: () => import('@/views/h5/design-audition'),
      meta: {
        title: '课程试听'
      } 
    },
    {
      path: '/h5/design-normal/:id([a-zA-Z0-9]+)',
      name: 'DesignNormal',
      component: () => import('@/views/h5/design-normal'),
      meta: {
        title: '课程报名'
      } 
    },
    {
      path: '/h5/design-jiaoda/:id([a-zA-Z0-9]+)', // 使用频率极低
      name: 'DesignJiaoda',
      component: () => import('@/views/h5/design-jiaoda'),
      meta: {
        title: '课程报名'
      } 
    },
    {
      path: '/h5/design-activity/:id([a-zA-Z0-9]+)',
      name: 'DesignActivity',
      component: () => import('@/views/h5/design-activity'),
      meta: {
        title: 'H5表单'
      } 
    },
    {
      path: '/h5/business-canvas/:id([a-zA-Z0-9]+)', // 使用频率极低
      name: 'BusinessCanvas',
      component: () => import('@/views/h5/business-canvas'),
      meta: {
        title: '商业画布'
      } 
    },
    {
      path: '/h5/f-partner/:id([a-zA-Z0-9]+)',
      name: 'FPartner',
      component: () => import('@/views/h5/f-partner'),
      meta: {
        title: '卡枚连城市合伙人（审核）评估表'
      } 
    },
    {
      path: '/h5/f-business/:id([a-zA-Z0-9]+)',
      name: 'FBusiness',
      component: () => import('@/views/h5/f-business'),
      meta: {
        title: '卡枚连企业会员评估表'
      } 
    },
    {
      path: '/h5/f-member/:id([a-zA-Z0-9]+)',
      name: 'FMember',
      component: () => import('@/views/h5/f-member'),
      meta: {
        title: '卡枚连黛色会员评估表'
      } 
    },
    {
      path: '/h5/define/:id([a-zA-Z0-9]+)',
      name: 'Define',
      component: () => import('@/views/h5/define'),
      meta: {
        title: '一起重新定义社交'
      }
    },
    {
      path: '/h5/researcher/:id([a-zA-Z0-9]+)', // 使用频率极低
      name: 'Researcher',
      component: () => import('@/views/h5/researcher'),
      meta: {
        title: '研究员申请表'
      }
    },
    {
      path: '/h5/researcher-pay/:id([a-zA-Z0-9]+)', // 使用频率极低
      name: 'ResearcherPay',
      component: () => import('@/views/h5/researcher-pay'),
      meta: {
        title: '研究员申请表'
      }
    },
    {
      path: '/h5/design-resource/:id([a-zA-Z0-9]+)',
      name: 'DesignResource',
      component: () => import('@/views/h5/design-resource'),
      meta: {
        title: '资源整合表'
      } 
    },
    {
      path: '/h5/design-channel-resource/:id([a-zA-Z0-9]+)',
      name: 'DesignChannelResource',
      component: () => import('@/views/h5/design-channel-resource'),
      meta: {
        title: '资源集成表'
      } 
    },
    {
      path: '/h5/design-resource-v2/:id([a-zA-Z0-9]+)',
      name: 'DesignResourceV2',
      component: () => import('@/views/h5/design-resource-v2'),
      meta: {
        title: '社交影响力梳理表',
        keepAlive: false
      } 
    },
    {
      path: '/h5/design-study-21/:id([a-zA-Z0-9]+)',
      name: 'DesignStudy21',
      component: () => import('@/views/h5/design-study-21'),
      meta: {
        title: '21天影响力训练营',
        keepAlive: false
      } 
    },
    {
      path: '/h5/bbs-salon/:id([a-zA-Z0-9]+)',
      name: 'BbsSalonV7',
      component: () => import('@/views/h5/bbs-salon'),
      meta: {
        title: '影响力启航论坛',
        keepAlive: false
      } 
    },
    {
      path: '/h5/resource-value/:id([a-zA-Z0-9]+)',
      name: 'ResourceValue',
      component: () => import('@/views/h5/resource-value'),
      meta: {
        title: '资源运营关键价值指数'
      } 
    },
    {
      path: '/h5/form/:id([a-zA-Z0-9]+)',
      name: 'Form',
      component: () => import('@/views/h5/form'),
      meta: {
        title: 'H5表单'
      }
    },
    {
      path: '/oa',
      name: 'oa',
      component: () => import('@/views/oa/index'),
      meta: {
        title: 'OA'
      }
    },
    {
      path: '/oa/activity',
      name: 'oaActivity',
      component: () => import('@/views/oa/activity'),
      meta: {
        title: '品牌活动'
      }
    },
    {
      path: '/oa/chart',
      name: 'oaChart',
      component: () => import('@/views/oa/chart'),
      meta: {
        title: '数据统计'
      }
    },
    {
      path: '/oa/activity/people',
      name: 'oaActivityPeople',
      component: () => import('@/views/oa/people'),
      meta: {
        title: '活动会员'
      }
    },
    {
      path: '/oa/data',
      name: 'oaData',
      component: () => import('@/views/oa/data'),
      meta: {
        title: '产品列表'
      }
    },
    {
      path: '/oa/order',
      name: 'oaOrder',
      component: () => import('@/views/oa/order'),
      meta: {
        title: '销售订单'
      }
    },
    {
      path: '/oa/customer',
      name: 'oaCustomer',
      component: () => import('@/views/oa/customer'),
      meta: {
        title: '我的客户'
      }
    },
    {
      path: '/oa/form',
      name: 'oaForm',
      component: () => import('@/views/oa/form'),
      meta: {
        title: '工作流程'
      }
    },
    {
      path: '/test/social-type/:id([a-zA-Z0-9]+)/:aid([a-zA-Z0-9]+)?',
      name: 'socialType',
      component: () => import('@/views/test/social-type'),
      meta: {
        title: '个人影响力评估'
      }
    },
    {
      path: '/test/social-free/:id([a-zA-Z0-9]+)',
      name: 'socialFree',
      component: () => import('@/views/test/social-free'),
      meta: {
        title: '个人影响力评估体验版'
      }
    },
    {
      path: '/test/social/:id([a-zA-Z0-9]+)',
      name: 'social',
      component: () => import('@/views/test/social'),
      meta: {
        title: '个人影响力评估'
      }
    },
    {
      path: '/test/social-tt/:id([a-zA-Z0-9]+)',
      name: 'socialTT',
      component: () => import('@/views/test/social-tt'),
      meta: {
        title: '个人影响力评估'
      }
    },
    {
      path: '/test/order/:ordersn([a-zA-Z0-9]+)',
      name: 'socialOrder',
      component: () => import('@/views/test/order'),
      meta: {
        title: '查看结果'
      }
    },
    {
      path: '/test/order-tt/:ordersn([a-zA-Z0-9]+)?',
      name: 'socialOrderTt',
      component: () => import('@/views/test/order-tt'),
      meta: {
        title: '查看电子评估报告'
      }
    },
    {
      path: '/test/free',
      name: 'testFree',
      component: () => import('@/views/test/free'),
      meta: {
        title: '生成量表链接'
      }
    },
    {
      path: '/link/sn/:sn([a-zA-Z0-9]+)',
      name: 'link',
      component: () => import('@/views/link/sn'),
      meta: {
        title: '图云互联'
      }
    },
    {
      path: '/power/b/:aid([a-zA-Z0-9]+)?',
      name: 'powerb',
      component: () => import('@/views/power/bindex'),
      meta: {
        title: '资源运营中心'
      }
    },
    {
      path: '/power/c/:bid([a-zA-Z0-9]+)?',
      name: 'powerc',
      component: () => import('@/views/power/cindex'),
      meta: {
        title: '整合我的资源'
      }
    },
    {
      path: '/photo/index',
      name: 'photoAblum',
      component: () => import('@/views/photo/album'),
      meta: {
        title: '活动图集'
      }
    },
    {
      path: '/photo/list/:aid([a-zA-Z0-9]+)',
      name: 'photoList',
      component: () => import('@/views/photo/list'),
      meta: {
        title: '图集预览'
      }
    },
    {
      path: '/oa/invoice/apply',
      name: 'oaInvoiceApply',
      component: () => import('@/views/oa/invoice/apply'),
      meta: {
        title: '发票申请'
      }
    },
    {
      path: '/westore/search',
      name: 'westoreSearch',
      component: () => import('@/views/westore/search'),
      meta: {
        title: '领取课程'
      }
    }
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js